import Draw from 'ol/interaction/Draw.js';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import {OSM, Vector as VectorSource, WMTS } from 'ol/source.js';
import { WMTS as TileGridWMTS } from 'ol/tilegrid.js';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer.js';
import {fromLonLat, transform , getTransform, transformExtent, get as getProjection} from 'ol/proj.js';
import proj4 from 'proj4';
import {register} from 'ol/proj/proj4.js';
import {applyTransform} from 'ol/extent.js';
import Feature from 'ol/Feature.js';
import Polygon from 'ol/geom/Polygon.js';
import Point from 'ol/geom/Point.js';
import Circle from 'ol/geom/Circle.js';
import { Fill, Stroke, Style} from 'ol/style.js';
import { fromLatLon } from 'utm';
import WKT from 'ol/format/WKT.js';

function registerProjection() {
    proj4.defs(
      'EPSG:25832',
      '+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs',
    );
    register(proj4);
}

export function showMap(wktList, rapportId) {
    if (!proj4.defs('EPSG:25832')) registerProjection();

    const featureList = [];
    const format = new WKT();
    wktList.forEach(wkt => {
//        if (rapportId <= 93992) {
//            featureList.push(
//                format.readFeature(wkt, {
//                    dataProjection: 'EPSG:4326',
//                    featureProjection: 'EPSG:25832'
//                })
//            );
//        } else
            featureList.push( format.readFeature(wkt) );
    });

    const source = new VectorSource({wrapX: false , features: featureList });
    const vector = new VectorLayer({ source: source }); //, style: styles });
    const extentDK = [120000, 5900000, 1000000, 6500000];
    const viewDK = new View({
        projection: 'EPSG:25832',
        extent: extentDK,
//        center: featureList[0].getGeometry().getFirstCoordinate(), // [609194.1028244805, 6215960.345171375],
    });
    const mapModel = new Map({
        view: viewDK
    });
    const raster = getRasterMap(extentDK);
    mapModel.setLayers([raster, vector]);
    viewDK.fit(featureList[0].getGeometry());
    if (viewDK.getZoom() > 11.0 ) viewDK.setZoom(11.0);

    return mapModel;
}
function drawMap(dispatch, georefStringUploadMsg) {

    if (!proj4.defs('EPSG:25832')) registerProjection();

    const extentDK = [120000, 5900000, 1000000, 6500000];
    const raster = getRasterMap(extentDK);

//    const coordinates = [[
//            [543216.95,6221418.12],[542102.13,6212945.49],[555479.97,6213837.34],[555034.04,6220972.19],[543216.95,6221418.12]
//        ]];
//        const polygonFeature = new Feature( new Polygon(coordinates) );
//            const source = new VectorSource({wrapX: false , features: [polygonFeature] });
    const source = new VectorSource({wrapX: false });
    source.on('addfeature', function(evt) {
        var coords = evt.feature.getGeometry().getCoordinates();
        const type = evt.feature.getGeometry().getType();
        if (type === 'Polygon') {
            const wkt = [];
            coords.forEach(e => e.forEach( i => wkt.push(i.join(" "))));
            let pol = type.toUpperCase() + '((' + wkt.join(',') + '))';
            dispatch(georefStringUploadMsg(pol));
        }
        if (type === 'LineString') {
            const wkt = [];
            coords.forEach(e => wkt.push( e.join(" ") ) );
            let line = type.toUpperCase() + '(' + wkt.join(',') + ')';
            dispatch(georefStringUploadMsg(line));
        }
        if (type === 'Point') {
            let point = type.toUpperCase() + '(' + coords.join(' ') + ')';
            dispatch(georefStringUploadMsg(point));
        }
    });
//    const fill = new Fill({
//        color: 'rgba(255,255,255,0.4)',
//    });
//    const stroke = new Stroke({
//        color: '#3399CC',
//        width: 1.25,
//    });
//
//    const styles = [
//        new Style({
//            image: new Circle({
//                fill: fill,
//                stroke: stroke,
//                radius: 5,
//            }),
//            fill: fill,
//            stroke: stroke,
//        }),
//     ];
//         const styles = [ new Style({
//            stroke: new Stroke({
//              color: 'rgb(53, 126, 221)',
//              width: 2,
//            }),
//            fill: new Fill({
//              color: 'rgba(0, 0, 255, 0.1)',
//            }),
//            image: new Circle({
//               fill: new Fill({
//                color: 'rgba(0, 0, 255, 0.1)',
//               }),
//               stroke: new Stroke({
//                 color: 'rgb(53, 126, 221)',
//                 width: 2,
//               }),
//               radius: 5,
//             }),
//          }),
//        ];
    const vector = new VectorLayer({ source: source}); //, style: styles  });
    const viewDK = new View({
        projection: 'EPSG:25832',
        extent: extentDK,
        center: [609194.1028244805, 6215960.345171375]
    });
    const mapModel = new Map({
        view: viewDK
    });
    mapModel.setLayers([raster, vector]);
    viewDK.fit(extentDK);

    const drawPoint = new Draw({
      source: source,
      type: 'Point',
      active: false
    });
    drawPoint.set('name','Point', true);
    mapModel.addInteraction(drawPoint);
    const drawPolygon = new Draw({
      source: source,
      type: 'Polygon',
      active: false
    });
    drawPolygon.set('name','Polygon', true);
    mapModel.addInteraction(drawPolygon);
    const drawLine = new Draw({
          source: source,
          type: 'LineString',
          active: false
        });
    drawLine.set('name','LineString', true);
    mapModel.addInteraction(drawLine);

    return mapModel;
}
function getRasterMap(extentDK) {
    return new TileLayer({
        visible: true,
        myval: true,
        extent: extentDK,
        source: new WMTS({
            url: 'https://services.datafordeler.dk/DKskaermkort/topo_skaermkort_daempet/1.0.0/Wmts?username=XXQZOUHAUE&password=Babayetu1!',
            layer: 'topo_skaermkort_daempet',
            matrixSet: 'View1',
            format: 'image/jpeg',
            projection: 'EPSG:25832',
            tileGrid: new TileGridWMTS({
                origin: [120000, 6500000],
                resolutions: [1638.4, 819.2, 409.6, 204.8, 102.4, 51.2, 25.6, 12.8, 6.4, 3.2, 1.6, .8, .4, .2],
                matrixIds: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13"]}),
            style: 'default'
        })
    });
}

export default drawMap;